import { SenderType } from "@/commons/services/Families";
import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileMessageReplyDetailState {
  /** 親メッセージのソートキー */
  parentMessagesSortKey: string;
  /** 利用者ID */
  residentId?: number;
  /** 家族ID */
  familyId?: number;
  /** グループID */
  groupId?: number;
  /** メンバーID */
  memberId?: number;
  /** メッセージを共有するか否か */
  isSharedMessages: boolean;
  /** 親メッセージのreceiverDetails */
  receiverDetails: Array<any>;

  /** メイン表示するラベル */
  mainName: string;
  /** サブ表示するラベル */
  subName: string;
  /** 日時 */
  datetime: number | null;
  /** 既読か否か */
  readed: boolean;
  /**  */
  type: string;
  /** ひもづくメッセージ */
  messages: Array<any>;
  /** 送信種別。利用者の送信種別 */
  senderType: SenderType;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileMessageReplyDetail store
 *
 * - store
 *   - メッセージ履歴の返信メッセージやりとりを保持する
 * - action, mutation
 *   - メッセージ履歴の返信メッセージやりとりを格納する
 */
@Module({ name: "mobileMessageReplyDetail" })
export default class MobileMessageReplyDetail extends VuexModule implements MobileMessageReplyDetailState {
  parentMessagesSortKey = "";
  residentId = undefined;
  familyId = undefined;
  groupId = undefined;
  memberId = undefined;

  isSharedMessages = false;
  receiverDetails = [];
  mainName = "";
  subName = "";
  datetime = 0;
  readed = false;
  type = "";
  messages = [];
  senderType = SenderType.LINE;
  exist = false;

  /** stateのgetters */
  get mobileMessageReplyDetailState(): MobileMessageReplyDetailState {
    const state: MobileMessageReplyDetailState = {
      parentMessagesSortKey: this.parentMessagesSortKey,
      residentId: this.residentId,
      familyId: this.familyId,
      groupId: this.groupId,
      memberId: this.memberId,

      isSharedMessages: this.isSharedMessages,
      receiverDetails: this.receiverDetails,
      mainName: this.mainName,
      subName: this.subName,
      datetime: this.datetime,
      readed: this.readed,
      type: this.type,
      messages: this.messages,
      senderType: SenderType.LINE,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_MESSAGE_REPLY_DETAIL(state: MobileMessageReplyDetailState) {
    this.parentMessagesSortKey = state.parentMessagesSortKey;
    this.residentId = state.residentId as never;
    this.familyId = state.familyId as never;
    this.groupId = state.groupId as never;
    this.memberId = state.memberId as never;

    this.isSharedMessages = state.isSharedMessages;
    this.receiverDetails = state.receiverDetails as never;
    this.mainName = state.mainName;
    this.subName = state.subName;
    this.datetime = state.datetime as never;
    this.readed = state.readed;
    this.type = state.type;
    this.messages = state.messages as never[];
    this.senderType = state.senderType;
    this.exist = true;

    return;
  }

  @Mutation
  private RESET_MOBILE_MESSAGE_REPLY_DETAIL() {
    this.parentMessagesSortKey = "";
    this.residentId = undefined;
    this.familyId = undefined;
    this.groupId = undefined;
    this.memberId = undefined;

    this.isSharedMessages = false;
    this.receiverDetails = [];
    this.mainName = "";
    this.subName = "";
    this.datetime = 0;
    this.readed = false;
    this.type = "";
    this.messages = [];
    this.senderType = SenderType.LINE;
    this.exist = false;

    return;
  }

  /**
   * ### メッセージ履歴の返信メッセージやりとりを更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileMessageReplyDetailState(payload: { state: MobileMessageReplyDetailState }): void {
    this.SET_MOBILE_MESSAGE_REPLY_DETAIL(payload.state);

    return;
  }

  /**
   * ### メッセージ履歴の返信メッセージやりとりを初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileMessageReplyDetailState(): void {
    this.RESET_MOBILE_MESSAGE_REPLY_DETAIL();

    return;
  }
}
